import { DateFromISO, TypeExtends } from "sb-js-extends";
DateFromISO();
TypeExtends();
export var getURLDate = function (dateString) {
    var date = Date.fromISO(dateString);
    return date ? "/" + date.formatDate("YYYYMMdd") : "";
};
//# sourceMappingURL=getURLDate.js.map